module.exports = __webpack_public_path__ + "img/zhaf_04.b6292546.jpg";